import { Box, Typography, useTheme, alpha } from '@mui/material'
import Grid from '@mui/material/Grid'
import colors from 'styles/colors'

export const DisplayBarBackground = ({
  children,
  backgroundColor,
  width,
  height,
  borderRadius = '10px',
  paddingX = '10px',
  paddingY = '15px',
  sx = {}
}) => {
  const theme = useTheme()
  return (
    <Box
      display='flex'
      alignItems='center'
      width={width}
      height={height}
      sx={{
        backgroundColor: backgroundColor || theme.palette.background.default,
        borderRadius: borderRadius,
        paddingY,
        paddingX,
        ...sx
      }}>
      {children}
    </Box>
  )
}

const ShadedScoreDisplayBar = ({
  labelComponent,
  scoreComponent,
  ...otherProps
}) => {
  return (
    <DisplayBarBackground {...otherProps}>
      {labelComponent}
      <Grid flex={1} display='inline-flex' justifyContent='right'>
        {scoreComponent}
      </Grid>
    </DisplayBarBackground>
  )
}

export const ScoreBar = ({
  score,
  label,
  selfScore = true,
  backgroundColor,
  labelTypoProps = {},
  scoreTypoProps = {},
  scaleStartPosition = 0.2
}) => {
  const getScoreBarWidth = score => {
    return (score * (1 - scaleStartPosition)) / 5 + scaleStartPosition
  }
  return (
    <ShadedScoreDisplayBar
      width={getScoreBarWidth(score)}
      paddingX={8}
      paddingY={4}
      backgroundColor={
        backgroundColor ||
        alpha(selfScore ? colors.Teal400 : colors.MidnightTeal300, 0.3)
      }
      labelComponent={
        <Typography variant='h5' {...labelTypoProps}>
          {label}
        </Typography>
      }
      scoreComponent={
        <Typography variant='h5' {...scoreTypoProps}>
          {score?.toFixed(2)}
        </Typography>
      }
    />
  )
}

export default ShadedScoreDisplayBar
